<template>
    <div class="color-input">
        <el-input :model-value="modelValue" size="small" :placeholder="placeholder" clearable
            @update:model-value="onInput"></el-input>
        <!-- 颜色名、transparent 选择器无法解析，只把 #RRGGBB 交给选择器显示 -->
        <el-color-picker :model-value="pickerValue" size="small" @change="onPick"></el-color-picker>
    </div>
</template>

<script>
// 颜色输入：#RRGGBB、小写颜色名或 transparent，可手填也可用颜色选择器
export const COLOR_PATTERN = /^(#[0-9a-fA-F]{6}|[a-z]+)$/

export default {
    name: 'PairingColorInput',
    props: {
        modelValue: { type: String, default: '' },
        placeholder: { type: String, default: '#RRGGBB / 颜色名 / transparent' },
    },
    emits: ['update:modelValue'],
    computed: {
        pickerValue() {
            return /^#[0-9a-fA-F]{6}$/.test(this.modelValue || '') ? this.modelValue : null
        },
    },
    methods: {
        onInput(value) {
            this.$emit('update:modelValue', (value || '').trim())
        },
        onPick(value) {
            this.$emit('update:modelValue', value ? value.toUpperCase() : '')
        },
    },
}
</script>

<style scoped>
.color-input {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
}
</style>
